import { render, staticRenderFns } from "./regionAuto.vue?vue&type=template&id=48d0c8c2"
import script from "./regionAuto.vue?vue&type=script&lang=js"
export * from "./regionAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports